export const TEACHER_DASHBOARD_NAVIGATION_TAG_NAME =
  "teacher_dashboard_navigation_enabled";
export const TEACHER_DASHBOARD_REPORTING_TITLE_TAG_NAME =
  "teacher_dashboard_reporting_title";
export const TEACHER_DASHBOARD_REPORTING_SUBHEADING_TAG_NAME =
  "teacher_dashboard_reporting_subheading";
export const TEACHER_DASHBOARD_NAVIGATION_ELEMENT_TYPE =
  "teacher_dashboard_navigation";

export const TEACHER_DASHBOARD_NAVIGATION_IDS = {
  HOME: "home",
  ADMIN: "admin",
  BEFORE_SCREENING: "before-screening",
  ASSIGN_SCREENER: "assign-screener",
  STUDENT_QRS: "student-qrs",
  RESULTS: "results",
  REPORTING: "reporting",
  NEW_CLASS_INSIGHTS: "new-class-insights",
  SCREENING_POINT_REPORT: "screening-point-report",
  PARENT_TEACHER_MEETING: "parent-teacher-meeting",
  CLASSROOM_HANDOVER: "classroom-handover",
  EOY_REPORT_ASSISTANT: "eoy-report-assistant",
  ALADDIN_EXPORT: "aladdin-export",
  SANDBOX: "sandbox",
};

export const TEACHER_DASHBOARD_NAVIGATION_ITEMS = [
  { number: 1, id: TEACHER_DASHBOARD_NAVIGATION_IDS.HOME, label: "Home", locked: true },
  { number: 2, id: TEACHER_DASHBOARD_NAVIGATION_IDS.ADMIN, label: "Classrooms" },
  { number: 3, id: TEACHER_DASHBOARD_NAVIGATION_IDS.ASSIGN_SCREENER, label: "Assign Screener" },
  { number: 4, id: TEACHER_DASHBOARD_NAVIGATION_IDS.BEFORE_SCREENING, label: "Before Screening" },
  { number: 5, id: TEACHER_DASHBOARD_NAVIGATION_IDS.STUDENT_QRS, label: "Student QRs" },
  { number: 6, id: TEACHER_DASHBOARD_NAVIGATION_IDS.RESULTS, label: "Results" },
  { number: 7, id: TEACHER_DASHBOARD_NAVIGATION_IDS.REPORTING, label: "Reporting" },
  { number: "7.1", id: TEACHER_DASHBOARD_NAVIGATION_IDS.NEW_CLASS_INSIGHTS, label: "New Class Insights", parentId: TEACHER_DASHBOARD_NAVIGATION_IDS.REPORTING },
  { number: "7.2", id: TEACHER_DASHBOARD_NAVIGATION_IDS.SCREENING_POINT_REPORT, label: "Screening Point Report", parentId: TEACHER_DASHBOARD_NAVIGATION_IDS.REPORTING },
  { number: "7.3", id: TEACHER_DASHBOARD_NAVIGATION_IDS.PARENT_TEACHER_MEETING, label: "Parent Teacher Meeting", parentId: TEACHER_DASHBOARD_NAVIGATION_IDS.REPORTING },
  { number: "7.4", id: TEACHER_DASHBOARD_NAVIGATION_IDS.EOY_REPORT_ASSISTANT, label: "End of Year Report Assistance", parentId: TEACHER_DASHBOARD_NAVIGATION_IDS.REPORTING },
  { number: "7.5", id: TEACHER_DASHBOARD_NAVIGATION_IDS.CLASSROOM_HANDOVER, label: "Classroom Observations", parentId: TEACHER_DASHBOARD_NAVIGATION_IDS.REPORTING },
  { number: 8, id: TEACHER_DASHBOARD_NAVIGATION_IDS.ALADDIN_EXPORT, label: "Aladdin Export" },
  { number: 9, id: TEACHER_DASHBOARD_NAVIGATION_IDS.SANDBOX, label: "Sandbox" },
];

export const DEFAULT_TEACHER_DASHBOARD_NAVIGATION_VALUES = Object.fromEntries(
  TEACHER_DASHBOARD_NAVIGATION_ITEMS.map((item) => [item.id, "ON"])
);
